import { dispatch } from '@pressreader/appstore';
import { loadHotspotInfoAction } from '@pressreader/sponsorship-core';

import { getProvider } from 'externalsystems/providers';
import { AuthorizeArgs } from 'externalsystems/providers/default.provider';

/**
 * Forwards authorization to the registered provider implementation and
 * triggers a hotspot-info reload on success.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
async function authorize({ provider, authtype, context = {} }: AuthorizeArgs): Promise<any> {
    const implementation = getProvider(provider);
    const authorizeResult = await implementation.authorize({ provider, authtype, context });
    if (authorizeResult) {
        dispatch(loadHotspotInfoAction({}));
    }
    return authorizeResult;
}

export { authorize };
